module.exports = __webpack_public_path__ + "static/media/teamBannerFour.b28c01b2.png";